module.exports = __webpack_public_path__ + "img/美食购物.cfef489b.png";